<template>
  <w-address-picker
    v-bind="$attrs"
    :url="terytUrl"
    :street-search-any="true"
    :set-city-as-street="false"
    :street-list-on-city-select="true"
    @update="$emit('update')"
  />
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

import { config } from '@/utils/config';

// @vuese
// Obudowanie komponentu w-jst-picker
// @group FormComponents
export default {
  components,
  inheritAttrs: false,
  data() {
    return {
      terytUrl: config.terytUrl
    };
  }
};
</script>
